import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";

class MarqueeTVTopContent extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "video_length",
        text: "Content Length (min)",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "minutes" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "viewers",
        text: "Unique Viewers",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "free_trial_viewers",
        text: "Free Trial Viewers",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", (cell && cell.value) || null, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "monthly_viewers",
        text: "Monthly Plan Viewers",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", (cell && cell.value) || null, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "annual_viewers",
        text: "Annual Plan Viewers",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "time_watched",
        text: "Min Time Watched",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "percent_watch_thru",
        text: "% Watch Thru",
        style: { width: "120px", minWidth: "120px" },
        formatExtraData: { type: "percentage", format: "0.00%" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("percent", cell && cell.value, "%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 15,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default MarqueeTVTopContent;
